import { getSalonAdminApiBaseUrl } from '../../salon-admin/utils/apiConfig';
import { hqSessionFetchInit } from '../../admin-shared/hqSessionAuth';
import { PORTAL_ID } from './api';

function adminBase() {
  return (getSalonAdminApiBaseUrl() || '').replace(/\/$/, '');
}

function hasPartnerSession() {
  return Boolean(localStorage.getItem('naturals_partner_userId'));
}

/**
 * @param {{ fromDate?: string, toDate?: string }} params
 */
export async function fetchPartnerStaffAnalytics({ fromDate, toDate } = {}) {
  const base = adminBase();
  if (!base || !hasPartnerSession()) {
    throw new Error('Not authenticated');
  }
  const qs = new URLSearchParams();
  if (fromDate) qs.set('fromDate', fromDate);
  if (toDate) qs.set('toDate', toDate);

  const res = await fetch(
    `${base}/partner/staff-analytics?${qs.toString()}`,
    hqSessionFetchInit(PORTAL_ID),
  );
  const data = await res.json().catch(() => ({}));
  if (!res.ok || !data?.success) {
    throw new Error(data?.error || 'Failed to load staff analytics');
  }
  return data.analytics || {};
}
